import { AreaType } from 'types';

export const areaToSlug = (area: AreaType): string => {
  switch (area) {
    case 'movimento':
      return 'movimento';

    case 'nutrição':
      return 'nutricao';

    case 'saúde':
      return 'saude';

    case 'bonus':
      return 'bonus';

    default:
      return '';
  }
};
